import React from 'react';
import Raven from "raven-js";
import {FormattedMessage} from "react-intl";

class GenericError extends React.Component {
    render() {
        return (
            <div className="error-container error-container-link" onClick={() => {
                Raven.lastEventId() && Raven.showReportDialog()
            }}>
                <h2>
                    <FormattedMessage id="error.generic.title" defaultMessage="Unexpected error occurred"/>
                </h2>
                <p>
                    <FormattedMessage id="error.generic.report"
                                      defaultMessage="Our team has been notified, but click here to fill the report"/>
                </p>
            </div>
        )
    }
}

export default GenericError;


// WEBPACK FOOTER //
// ./src/containers/Error/GenericError.jsx